export default __webpack_public_path__ + "static/media/per-diversity.fc420a9f.svg";